import { Component, OnInit, OnDestroy } from '@angular/core';
import { sweetAlert } from 'src/app/utils/swal';
import { takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import * as moment from 'moment-timezone';
import { DispatchCenterService } from 'src/app/component/dashboard/dashboard-service/dispatch-center-service';

@Component({
  selector: 'app-notification-details',
  templateUrl: './notification-details.component.html',
  styleUrls: ['./notification-details.component.css']
})
export class NotificationDetailsComponent implements OnInit, OnDestroy {
  search = '';
  user;
  timeZone;
  searchDate;
  notifications = [];
  startDate;
  constructor(
    private sharedDataService : SharedDataService,
    private dispatchCenterService: DispatchCenterService
  ) {
  }

  ngOnInit() {
    this.getUser();
    this.getNotifications();
  }

  getNotifications() {
    this.dispatchCenterService
      .getNotifications(this.startDate)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.notifications = data;
        }
      }, err => {
        // sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getUser() {
    this.sharedDataService.getUser().subscribe(data => {
      if (data) {
        this.user = data;
        this.timeZone = this.user.timeZone;
          this.searchDate = moment().tz(this.timeZone).startOf('day').toISOString();
          this.startDate = moment().tz(this.timeZone).startOf('day').toISOString();
      }
    })
  }

  onSearchDateChange(event) {
    this.searchDate = event.toISOString();
    this.startDate = this.searchDate;
    this.getNotifications();
  }

  ngOnDestroy(): void {
  }
}
